import { render, staticRenderFns } from "./SortHeader.vue?vue&type=template&id=4108a426"
import script from "./SortHeader.vue?vue&type=script&lang=js"
export * from "./SortHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports